import Swiper, { Navigation, Pagination, Autoplay } from 'swiper';


Swiper.use([Navigation, Pagination, Autoplay]);


export const initSwipers = function() {

   console.log("initSwipers3")

    let featuresSwiper  = new Swiper('.features-carousel', {
        spaceBetween: 20,
        grabCursor: true,
        loop: true,
        autoplay: {
            delay: 3000,
        },
        slidesPerView: 1,
        breakpoints: {
            640: {
                slidesPerView: 2,
            },
            768: {
                slidesPerView: 2,
            },
            1024: {
                slidesPerView: 3,
            },
        },
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev", 
        },
    });

    let relatedSwiper  = new Swiper('.related-carousel', {
        spaceBetween: 20,
        grabCursor: true,
        slidesPerView: 1,
        breakpoints: {
            640: {
                slidesPerView: 2,
            },
            768: {
                slidesPerView: 2,
            },
            1024: {
                slidesPerView: 3,
            },
        }
    });


    let storiesSwiper = new Swiper('.stories-carousel', {
        spaceBetween: 20,
        grabCursor: true,
        slidesPerView: 1,
        breakpoints: {
            768: {
                slidesPerView: 3,
            },
        },
        navigation: {
            nextEl: ".stories-button-next",
            prevEl: ".stories-button-prev",
        },
    });

    let mediaSwiper  = new Swiper('.media-carousel', {
        spaceBetween: 0,
        //grabCursor: true,
        slidesPerView: 1,
        pagination: {
            el: ".swiper-pagination",
        },
    });

    


    


} 